import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import { CallNative } from '../../../services/EpicContextService/call.native';
import { EpicContextService } from '../../../services/EpicContextService/epic.context';
import * as T_T from 'cryface';

@Component
export default class HybridTestDemoPage extends Vue {
    public data: string = '';

    public epicContext: any = EpicContextService.instance();

    public demo: any = 'Hybrid Waiting For SettingEpicContext';

    public manual = 'Manual Test';

    public manualParam: any = '';

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('epicContext', { immediate: true, deep: true })
    public onEpicContext(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            const demo = EpicContextService.getParam('demo');
            const manual = EpicContextService.getParam('manual');
            if (T_T.simpleDetect(demo)) {
                this.demo = demo!.value;
            }
            if (T_T.simpleDetect(manual)) {
                this.manual = manual!.value;
            }
        }
    }

    public created() {
        // console.log(window);
        this.testSetDemo();
        // CallNative.runSetEpicContext();
    }

    public mounted() {
    }

    public testSetDemo() {
        // EpicContextService.setParamsMobile([{ key: 'demo', value: 'Hybrid Waiting Test Settings' }]);
        // EpicContextService.setParam('demo', 'Hybrid Waiting Test Settings Override');
        const _window: any = window;
        _window.epicFunctions.setParam('demo', 'Hybrid Waiting');
        EpicContextService.setParam('manual', 'Menual Test');
    }

    public testSetDemoAnother() {
        EpicContextService.setParams([{ key: 'demo', value: 'Hybrid Waiting Test Settings Another' }]);
    }

    public manualSetDemoParam() {
        const _window: any = window;
        EpicContextService.setParam('manual', this.manualParam);
        _window.epicFunctions.setParam('demo', this.manualParam);
    }
}
